import SdpTransform from 'sdp-transform'
import { logger } from './index'

function isSupported () {
  if (
    !window.RTCPeerConnection ||
        !window.RTCPeerConnection.prototype.addTransceiver
  ) {
    return false
  }

  return true
}

export interface CodecInfo {
  payload: number
  codec: string
  config?: string
}

function getCapacity () {
  if (!isSupported()) return Promise.reject('RTCPeerConnection no support')

  let pc

  try {
    pc = new RTCPeerConnection()
    pc.addTransceiver('video', { direction: 'recvonly' })
    pc.addTransceiver('audio', { direction: 'recvonly' })
  } catch (e: any) {
    return Promise.reject(e?.message)
  }

  return pc.createOffer()
    .then(offer => {
      logger.log(offer.sdp)

      if (!offer.sdp) {
        return Promise.reject('createOffer no sdp')
      }

      const sdpJson = SdpTransform.parse(offer.sdp)

      const vMedia = sdpJson.media?.filter(x => x.type === 'video')[0]
      const aMedia = sdpJson.media?.filter(x => x.type === 'audio')[0]

      const vCodecs: CodecInfo[] = vMedia?.rtp?.filter(x => x.codec === 'VP8' || x.codec === 'VP9' || x.codec === 'H264')
      const aCodecs: CodecInfo[] = aMedia?.rtp?.filter(x => x.codec === 'opus')
      const vFmtp = vMedia?.fmtp
      const aFmtp = aMedia?.fmtp

      vFmtp && vCodecs.map(codec => {
        codec.config = vFmtp.filter(x => x.payload === codec.payload)[0]?.config
      })

      aFmtp && aCodecs.map(codec => {
        codec.config = aFmtp.filter(x => x.payload === codec.payload)[0]?.config
      })

      pc.close()

      return {
        video: vCodecs,
        audio: aCodecs
      }
    })
}

const isEncodedTransformSupported = () =>
  typeof TransformStream !== 'undefined' &&
  typeof RTCRtpSender !== 'undefined' &&
  typeof RTCRtpReceiver !== 'undefined' &&
  typeof RTCRtpScriptTransform !== 'undefined' &&
  'transform' in RTCRtpSender.prototype &&
  'transform' in RTCRtpReceiver.prototype &&
  isWorkerSupported() &&
  isMessageChannelSupported()

export const isWorkerSupported = () => typeof window !== 'undefined' && window.Worker
export const isMessageChannelSupported = () => typeof MessageChannel !== 'undefined'


const isLegacyEncodedTransformSupported = () =>
  typeof TransformStream !== 'undefined' &&
  typeof RTCRtpSender !== 'undefined' &&
  typeof RTCRtpReceiver !== 'undefined' &&
  typeof (RTCRtpSender.prototype as any).createEncodedStreams !== 'undefined' &&
  typeof (RTCRtpReceiver.prototype as any).createEncodedStreams !== 'undefined'

export { isSupported, getCapacity, isEncodedTransformSupported, isLegacyEncodedTransformSupported }